import React from "react"

export default function ErrorComponent({ error, classes, }) {
  if (!error || "Token not set." === error) {
    return null
  }

  const setClasses = classes ? ` ${classes}` : ""

  return (
    <div>
      <div
        className={`alert alert-danger alert-dismissible fade show ${setClasses}`}
        role="alert"
      >
        {error}
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
    </div>
  )
}
